"use client";

import React from "react";
import { useTranslation } from "react-i18next";
import MissingData from "@/components/common/MissingData";
import Container from "@/components/common/container";

export default function CatchAllPage() {
  const { t: ct } = useTranslation("common");

  return (
    <Container>
      <MissingData
        title={ct("notFound.title")}
        description={ct("notFound.subtitle")}
      />
    </Container>
  );
}
